"use strict";
/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

/**
 * @module  reminders
 * @decision This module provides the Web Portal with the functionality for 'Reminders'
 * including: listing, adding, removing, etc.
 *
 */

module.exports = function (config, get, post) {
	return {
		list: list,
		add: add,
		remove: remove,
		edit: edit,
		history: {
			create: create_history,
			accept: accept_history,
			deny: deny_history,
			respond: respond_history,
			list: list_history,
			listOwn: list_own_history,
			pending: list_pending
		}
	};

	/**
	 * [list description]
	 * @return {[type]} [description]
	 */
	function list() {
		return get("/v2/reminders/list", {});
	}

	/**
	 * [add description]
	 * @param {[type]} content  [description]
	 * @param {[type]} schedule [description]
	 */
	function add(content, schedule, notification, type) {
		return post("/v2/reminders/add", {
			content: content,
			schedule: schedule || undefined,
			notification: notification,
			type: type
		});
	}

	/**
	 * [remove description]
	 * @param  {[type]} reminder [description]
	 * @return {[type]}          [description]
	 */
	function remove(reminder) {
		return post("/v2/reminders/remove", {
			reminder: reminder
		});
	}

	/**
	 * [edit description]
	 * @param  {[type]} reminder [description]
	 * @param  {[type]} content  [description]
	 * @param  {[type]} schedule [description]
	 * @return {[type]}          [description]
	 */
	function edit(reminder, content, schedule, notification, type) {

		return post("/v2/reminders/edit", {
			content: content,
			reminder: reminder,
			schedule: schedule || undefined,
			notification: notification,
			type: type
		});
	}

	/**
	 * Creates a reminder history item for the currently displayed reminder
	 * @param  {String} reminder The id of the reminder that this is for
	 * @return {Promise}          Resolves to reminder history data
	 */
	function create_history(reminder, reason) {
		return post("/v2/reminders/history/create", {
			reminder: reminder,
			reason: reason
		});
	}

	/**
	 * Accepts a reminder history item
	 * @param  {String}  history The id of the reminder history item to accept
	 * @return {Promise}         Resolves if the acceptance was successful
	 */
	function accept_history(history) {
		return post("/v2/reminders/history/accept", {
			history: history,
		});
	}

	function deny_history(history) {
		return post("/v2/reminders/history/deny", {
			history: history,
		});
	}

	function respond_history(history, response) {
		return post("/v2/reminders/history/respond", {
			history: history,
			response: response
		});
	}

	function list_history(query, page, start, end) {
		if (query === undefined) query = "";
		if (page === undefined) page = 0;
		if (start === undefined) start = "";
		if (end === undefined) end = "";
		return get("/v2/reminders/history/list", {
			page: page,
			start: start,
			end: end,
			query: query
		});
	}

	function list_own_history(query, page, start, end) {
		if (query === undefined) query = "";
		if (page === undefined) page = 0;
		if (start === undefined) start = "";
		if (end === undefined) end = "";
		return get("/v2/reminders/history/list/own", {
			page: page,
			start: start,
			end: end,
			query: query
		});
	}

	function list_pending(){
		return get("/v2/reminders/history/list/pending");
	}
};
